import Source from "./Source";
import SourceCode from "./SourceCode";
import SourceType from "./SourceType";

export default class SourceStore {

    public constructor(private readonly sources: Source[]) {
    }

    public getSource(code: SourceCode, type?: SourceType): Source {
        const source = this.sources.find(findSource =>
            findSource.getCode() === code && (type === undefined || findSource.getType() === type));
        if (source === undefined) {
            throw new Error('Source not found: ' + code + (type ? '/' + type : ''));
        }
        return source;
    }
}
